"use client";

import React, { useState, useEffect } from "react";
import { useIsPartnerBranded } from "app/context/BrandingContext";

interface AppLoaderProps {
  width?: number;
  height?: number;
}

const AppLoader: React.FC<AppLoaderProps> = ({ width = 150, height = 150 }) => {
  const [isMobile, setIsMobile] = useState(false);
  const isPartnerBranded = useIsPartnerBranded();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const loaderWidth = isMobile ? 40 : width;
  const loaderHeight = isMobile ? 40 : height;

  return (
    <div className="flex h-full flex-1 items-center justify-center">
      <div
        style={{
          width: `calc(${loaderWidth}px * var(--wm))`,
          height: `calc(${loaderHeight}px * var(--hm))`,
        }}
      >
        {isPartnerBranded ? (
          // The loader gif carries Relm's mark — use a spinner in the partner's colour instead.
          <span
            className="block h-full w-full animate-spin rounded-full border-[3px] border-brand-faint border-t-brand"
            role="status"
            aria-label="Loading"
          />
        ) : (
          <img
            src="/gifs/relm-loader.gif"
            alt="Loader"
            width={loaderWidth}
            height={loaderHeight}
            style={{
              width: `calc(${loaderWidth}px * var(--wm))`,
              height: `calc(${loaderHeight}px * var(--hm))`,
            }}
          />
        )}
      </div>
    </div>
  );
};

export default AppLoader;
